import React from 'react';
import PropTypes from 'prop-types';
import { translate as translateHOC } from 'react-admin';
import { Card, CardContent, CardActions, Typography, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
  card: {
    height: '90%',
    margin: 'auto',
    marginTop: '10%',
    maxWidth: '590px',
    width: '100%',
  },
  guide: {
    fontSize: '20px',
    textAlign: 'center',
  },
  contents: {
    paddingTop: '30px',
    paddingBottom: '0',
  },
  actions: {
    flexDirection: 'column',
    padding: '0',
  },
  button: {
    '&:hover': {
      background: 'unset',
    },
  },
  primaryButton: {
    background: theme.palette.primary.main,
    borderRadius: '35px',
    color: '#FFFFFF',
    padding: '20px',
    width: '100%',
    '&:hover': {
      background: '#303F9F',
    },
  },
});

class AccessDenied extends React.Component {
  constructor(props) {
    super(props);
    this.redirectToHome = this.redirectToHome.bind(this);
  }

  redirectToHome() {
    const { history } = this.props;
    history.push('/');
  }

  render() {
    const { classes, translate } = this.props;
    return (
      <Card className={classes.card}>
        <CardContent className={classes.contents}>
          <Typography className={classes.guide}>{translate('notification.customerDeny')}</Typography>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button
            id="Selenium-AccessDenied-Button"
            className={classes.button}
            classes={{ label: classes.primaryButton }}
            fullWidth
            onClick={this.redirectToHome}
          >
            {translate('common.redirectHome')}
          </Button>
        </CardActions>
      </Card>
    );
  }
}

AccessDenied.propTypes = {
  classes: PropTypes.shape({}),
  history: PropTypes.shape({}),
  translate: PropTypes.func,
};

export default translateHOC(withStyles(styles)(AccessDenied));
